/* Superoom - DRAWER OFFERS. Four, only ever one on screen: Power Couple upgrade (subscribed to one
   formula, FOLLOWS THE MINI THEY CHOSE); the way back (already on a couple); Full Collection (OTP
   50ml); Mini Collection (OTP 15ml). The last two REPLACE what they contain.

   THE TWO CARDS ARGUE DIFFERENTLY: the 50ml set on "fourth bottle free" (134.99 vs 149.97 for
   three), the minis on PER BOTTLE, because 54.99 vs 83.97 is nearer two free than one.

   THE MINI ROW IS A MULTI-SELECT: all four shown, the ones held ticked, tapping toggles. BUT IT SAYS
   WHEN THEY ARE OVERPAYING - two singles is 55.98 against 54.99 for the set.

   IT CONVERTS, IT DOES NOT ADD: added first, old line removed only once the add comes back ok. */
(function () {
  if (window.__superoomCartPair) return;
  window.__superoomCartPair = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CDN = 'https://cdn.shopify.com/s/files/1/0868/2599/2525/files/';
  var PLAN_COUPLE = 692142211405;
  var PLAN_SINGLE = 692504854861;

  var COUPLE_BY_PAIR = {
    'chaga|cordyceps':     { handle: 'the-glow-getter-cordyceps-chaga',         id: 53530150273357, title: 'Energy & Defence' },
    'chaga|lionsmane':     { handle: 'the-bright-one-lions-mane-chaga',         id: 53530151715149, title: 'Clarity & Glow' },
    'chaga|reishi':        { handle: 'the-rebuilder-reishi-chaga',              id: 53530154336589, title: 'Deep Sleep & Repair' },
    'cordyceps|reishi':    { handle: 'the-olympian-cordyceps-reishi-1',         id: 53530155778381, title: 'Train & Recover' },
    'cordyceps|lionsmane': { handle: 'the-peak-performer-lions-mane-cordyceps', id: 53530156073293, title: 'Focus & Fuel' },
    'lionsmane|reishi':    { handle: 'the-professional-lions-mane-reishi',      id: 53530156630349, title: 'Focus & Calm' }
  };
  var COUPLE_FORMULAS = {
    'the-glow-getter-cordyceps-chaga': ['cordyceps', 'chaga'],
    'the-bright-one-lions-mane-chaga': ['lionsmane', 'chaga'],
    'the-rebuilder-reishi-chaga': ['reishi', 'chaga'],
    'the-olympian-cordyceps-reishi-1': ['cordyceps', 'reishi'],
    'the-peak-performer-lions-mane-cordyceps': ['lionsmane', 'cordyceps'],
    'the-professional-lions-mane-reishi': ['lionsmane', 'reishi']
  };

  var SINGLE_50 = { reishi: 54297991545165, lionsmane: 54305197719885, cordyceps: 54305082900813, chaga: 54304606093645 };
  var MINI = {
    reishi: { id: 54297991577933, name: 'Reishi', img: 'Reishi-15ml-white.png',
      info: 'Triterpenes and beta-glucans, studied for switching the nervous system off. Sleep, not sedation.' },
    cordyceps: { id: 54305082933581, name: 'Cordyceps', img: 'Cordy-15ml-white.png',
      info: 'Cordycepin and adenosine, studied in exercise trials for oxygen use under load.' },
    chaga: { id: 54304606126413, name: 'Chaga', img: 'Chaga-15ml-white.png',
      info: 'Betulinic acid and beta-glucans, wild-foraged from Arctic birch. Studied for free radicals.' },
    lionsmane: { id: 54305197752653, name: "Lion's Mane", img: 'Lion-15ml-white.png',
      info: 'Hericenones and erinacines, studied for helping the brain build new connections.' }
  };
  var SLUGS = ['reishi', 'cordyceps', 'chaga', 'lionsmane'];
  var MINI_PRICE = 2799, FIFTY_PRICE = 4999;
  var FULL = { id: 51329082556749, handle: 'the-wild-life-collection', price: 13499, img: 'WLC-updated-summer.png' };
  var MINIS_COL = { id: 54298542899533, handle: 'the-wild-life-collection', price: 5499, img: '33Artboard_1_copy_2.png' };

  var DEFAULT_PARTNER = { reishi: 'lionsmane', lionsmane: 'reishi', cordyceps: 'reishi', chaga: 'lionsmane' };
  var FORMULA_NAME = { reishi: 'Reishi', lionsmane: "Lion's Mane", cordyceps: 'Cordyceps', chaga: 'Chaga' };
  var ACCENT = { reishi: '#AA1111', lionsmane: '#854F0B', cordyceps: '#993C1D', chaga: '#0D6878' };

  var COUPLE_HANDLES = Object.keys(COUPLE_BY_PAIR).map(function (k) { return COUPLE_BY_PAIR[k].handle; });
  var MINI_IDS = SLUGS.map(function (s) { return MINI[s].id; });
  var FIFTY_IDS = SLUGS.map(function (s) { return SINGLE_50[s]; });

  var timer = null, busy = false, openInfo = null;
  var lastHtml = null, lastAccent = null, lastC = null, lastMode = '';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function money(p) { return '£' + (p / 100).toFixed(2); }
  function isCouple(i) { return COUPLE_HANDLES.indexOf((i.handle || '').toLowerCase()) !== -1; }
  function isClaimed(i) { var p = i.properties; return !!(p && p['_first_drop_kit']); }
  function vid(i) { return i.variant_id || i.id; }
  function coupleFor(a, b) { return COUPLE_BY_PAIR[[a, b].sort().join('|')] || null; }

  function formulaKey(item) {
    var t = (item.product_title || '').toLowerCase().replace(/[^a-z]/g, '');
    if (t.indexOf('reishi') !== -1) return 'reishi';
    if (t.indexOf('lionsmane') !== -1) return 'lionsmane';
    if (t.indexOf('cordyceps') !== -1) return 'cordyceps';
    if (t.indexOf('chaga') !== -1) return 'chaga';
    return null;
  }

  function coupleInCart(cart) {
    var line = cart.items.filter(function (i) { return isCouple(i) && !!i.selling_plan_allocation; })[0];
    if (!line) return null;
    var f = COUPLE_FORMULAS[(line.handle || '').toLowerCase()];
    return f ? { line: line, formulas: f } : null;
  }

  function candidate(cart) {
    var subs = cart.items.filter(function (i) { return !!i.selling_plan_allocation; });
    if (subs.length !== 1) return null;
    var line = subs[0];
    if (isCouple(line) || cart.items.some(isCouple)) return null;
    var key = formulaKey(line);
    if (!key) return null;
    var gift = cart.items.filter(isClaimed)[0];
    var giftKey = gift ? formulaKey(gift) : null;
    var partnerKey = (giftKey && giftKey !== key) ? giftKey : DEFAULT_PARTNER[key];
    var pair = partnerKey ? coupleFor(key, partnerKey) : null;
    if (!pair) return null;
    return { line: line, key: key, partnerKey: partnerKey, followsGift: !!(giftKey && giftKey !== key),
      pair: { handle: pair.handle, id: pair.id, title: pair.title, partner: FORMULA_NAME[partnerKey],
              accent: ACCENT[partnerKey] || '#0B312C' } };
  }

  /* held maps slug -> line key for every PAID mini, which is what makes the row a toggle. */
  function otpCandidate(cart) {
    if (cart.items.some(function (i) { return !!i.selling_plan_allocation; })) return null;
    if (cart.items.some(function (i) { return vid(i) === FULL.id || vid(i) === MINIS_COL.id; })) return null;
    var hasFifty = cart.items.some(function (i) { return FIFTY_IDS.indexOf(vid(i)) !== -1; });
    var miniLines = cart.items.filter(function (i) { return MINI_IDS.indexOf(vid(i)) !== -1 && !isClaimed(i); });
    if (!hasFifty && !miniLines.length) return null;
    var held = {}, qty = 0;
    miniLines.forEach(function (i) {
      qty += i.quantity;
      SLUGS.forEach(function (s) { if (MINI[s].id === vid(i)) held[s] = i.key; });
    });
    return { full: hasFifty, held: held, qty: qty };
  }

  function style() {
    if (document.getElementById('sr-pair-style')) return;
    var s = document.createElement('style');
    s.id = 'sr-pair-style';
    s.textContent =
      /* ONE ASK PER CART. A class on <html>, not .hidden: the CRO module repaints and resets its own. */
    'html.sr-pair-on [data-cro-crosssell]{display:none!important}' +
    '.sr-pair{margin:0 0 10px;border:1px solid #DCD6C2;border-radius:10px;background:#F4F2E8;padding:9px 10px}' +
    '.sr-pair__tag{display:inline-block;font-family:"Montserrat",sans-serif;font-size:8.5px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#0B312C;background:#E4DFC7;border-radius:999px;padding:2px 7px}' +
    '.sr-pair__t{font-family:"ITC New Baskerville",Georgia,serif;font-size:14px;line-height:1.15;color:#0B312C;font-weight:500;margin:5px 0 0}' +
    '.sr-pair__t b{font-weight:500;border-bottom:2px solid var(--pa,#0B312C);padding-bottom:1px}' +
    '.sr-pair__s{font-family:"Public Sans",sans-serif;font-size:10.5px;line-height:1.4;color:#5C6B63;margin:3px 0 0}' +
    '.sr-pair__s b{color:#0B312C;font-weight:700}' +
    '.sr-pair__row{display:flex;align-items:center;gap:8px;margin-top:8px}' +
    '.sr-pair__go{flex:1 1 auto;font-family:"Montserrat",sans-serif;font-size:9.5px;font-weight:800;letter-spacing:.05em;text-transform:uppercase;color:#fff;background:#0B312C;border:0;border-radius:999px;padding:8px 12px;cursor:pointer;line-height:1;transition:opacity .15s ease}' +
    '.sr-pair__go:hover{opacity:.88}' +
    '.sr-pair__go[disabled]{opacity:.55;cursor:default}' +
    '.sr-pair__shot{display:block;width:100%;height:78px;object-fit:cover;object-position:center 42%;border-radius:7px;margin:8px 0 0;background:#EDEAE0}' +
    '.sr-pair__shot--fit{height:118px;width:auto;max-width:100%;object-fit:contain;background:#fff;' +
    'border:1px solid #E4E0D2;border-radius:9px;padding:4px;margin:8px auto 0}' +
    '.sr-pair__or{font-family:"Public Sans",sans-serif;font-size:9.5px;color:#8A938C;margin:10px 0 0;padding-top:9px;border-top:1px solid #E4E0D2}' +
    '.sr-pair__ones{display:grid;grid-template-columns:repeat(4,1fr);gap:5px;margin:6px 0 0}' +
    '.sr-pair__cell{position:relative;min-width:0}' +
    '.sr-pair__one{display:flex;flex-direction:column;align-items:center;gap:2px;background:#fff;border:1px solid #E4E0D2;border-radius:8px;padding:8px 3px 6px;cursor:pointer;font:inherit;transition:border-color .15s ease;min-width:0;width:100%}' +
    '.sr-pair__one:hover{border-color:#0B312C}' +
    '.sr-pair__one[disabled]{opacity:.5;cursor:default}' +
    '.sr-pair__cell[data-on="1"] .sr-pair__one{border:1.5px solid #0B312C;padding:7.5px 2.5px 5.5px;background:#FBFAF6}' +
    '.sr-pair__one img{width:22px;height:30px;object-fit:contain;display:block}' +
    '.sr-pair__on{display:block;max-width:100%;font-family:"Public Sans",sans-serif;font-size:8.5px;font-weight:700;color:#14211C;line-height:1.15;text-transform:none;letter-spacing:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.sr-pair__op{font-family:"Public Sans",sans-serif;font-size:8.5px;color:#8A938C;text-transform:none;letter-spacing:0}' +
    '.sr-pair__tick{position:absolute;left:4px;top:4px;width:14px;height:14px;border-radius:50%;background:#0B312C;display:none;place-items:center;z-index:2}' +
    '.sr-pair__cell[data-on="1"] .sr-pair__tick{display:grid}' +
      /* THE DOT SITS ON THE BOTTLE: at 12px in 8.5px type nobody saw it. Absolute on the cell so it
         cannot squeeze the name, 17px so it reads as a control, and it wiggles because a static grey
         circle is not an invitation to hover. */
    '.sr-pair__i{position:absolute;top:3px;right:3px;z-index:3;width:17px;height:17px;border-radius:50%;border:1px solid #B9C6BD;background:#fff;color:#0B312C;font-family:"Public Sans",serif;font-size:10px;font-style:italic;font-weight:700;line-height:1;cursor:pointer;display:grid;place-items:center;animation:sr-wig 3.6s ease-in-out infinite;transform-origin:50% 50%}' +
    '.sr-pair__i:hover,.sr-pair__i[aria-expanded="true"]{border-color:#0B312C;background:#0B312C;color:#fff;animation:none}' +
    '.sr-pair__cell:hover .sr-pair__i{animation:none}' +
    '.sr-pair__i::after{content:"";position:absolute;inset:-7px;border-radius:50%}' +
    '@keyframes sr-wig{0%,70%,100%{transform:rotate(0)}74%{transform:rotate(-14deg)}78%{transform:rotate(12deg)}82%{transform:rotate(-10deg)}86%{transform:rotate(8deg)}90%{transform:rotate(-5deg)}94%{transform:rotate(2deg)}}' +
    '@media(prefers-reduced-motion:reduce){.sr-pair__i{animation:none}}' +
    '.sr-pair__sum{font-family:"Public Sans",sans-serif;font-size:9.5px;line-height:1.35;color:#5C6B63;margin:6px 0 0;text-align:center}' +
    '.sr-pair__sum b{color:#0B312C;font-weight:700}' +
      /* THE RESERVED SLOT holds its height even when empty, so a tooltip cannot move Checkout. */
    '.sr-pair__slot{min-height:42px;margin:7px 0 0}' +
    '.sr-pair__pop{font-family:"Public Sans",sans-serif;font-size:9.5px;line-height:1.4;color:#4A5750;background:#fff;border:1px solid #E4E0D2;border-radius:8px;padding:6px 8px}' +
    '.sr-pair__pop b{font-family:"Montserrat",sans-serif;font-size:7.5px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#AA1111;margin-right:5px}' +
    '.sr-pair--down{background:none;border:0;border-top:1px solid #E4E0D2;border-radius:0;padding:9px 2px 0;margin:2px 0 10px}' +
    '.sr-pair__dq{font-family:"Public Sans",sans-serif;font-size:10.5px;line-height:1.5;color:#8A938C;margin:0}' +
      /* The theme uppercases buttons, which turned these into REISHI and CHAGA. */
    '.sr-pair__dn{font-family:"Public Sans",sans-serif;font-size:10.5px;font-weight:700;color:#0B312C;background:none;border:0;padding:0;margin:0;cursor:pointer;text-decoration:underline;text-underline-offset:2px;text-transform:none;letter-spacing:0}' +
      '.sr-pair__dn:hover{color:#AA1111}';
    document.head.appendChild(s);
  }

  function refreshDrawer() {
    var d = document.getElementById('cart-drawer');
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true })); } catch (e) {}
    if (d && typeof d.show === 'function') { d.show(); return; }
    if (d && typeof d.open === 'function') { d.open(); return; }
    window.location.reload();
  }

  function purge(match, depth) {
    if (depth > 4) return Promise.resolve();
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (fresh) {
        var next = fresh.items.filter(match)[0];
        if (!next) return null;
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: next.key, quantity: 0 })
        }).then(function () { return purge(match, depth + 1); });
      });
  }

  function add(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  function convert(c, btn) {
    if (busy) return;
    busy = true; btn.disabled = true; btn.textContent = 'Swapping…';
    add([{ id: c.pair.id, quantity: 1, selling_plan: PLAN_COUPLE }])
      .then(function () {
        return purge(function (i) {
          var k = formulaKey(i);
          if (!!i.selling_plan_allocation && !isCouple(i) && k === c.key) return true;
          if (isClaimed(i) && (k === c.key || k === c.partnerKey)) return true;
          return false;
        }, 0);
      })
      .then(function () { busy = false; btn.disabled = false; refreshDrawer(); })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = 'Make it a Power Couple'; });
  }

  function downgrade(keep, btn) {
    if (busy) return;
    var id = SINGLE_50[keep];
    if (!id) return;
    busy = true; btn.disabled = true; btn.textContent = 'Switching…';
    add([{ id: id, quantity: 1, selling_plan: PLAN_SINGLE }])
      .then(function () { return purge(function (i) { return isCouple(i); }, 0); })
      .then(function () { busy = false; refreshDrawer(); })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = FORMULA_NAME[keep]; });
  }

  function addCollection(full, btn) {
    if (busy) return;
    busy = true; btn.disabled = true; btn.textContent = 'Adding…';
    var ids = full ? FIFTY_IDS : MINI_IDS;
    add([{ id: full ? FULL.id : MINIS_COL.id, quantity: 1 }])
      .then(function () { return purge(function (i) { return ids.indexOf(vid(i)) !== -1 && !isClaimed(i); }, 0); })
      .then(function () { busy = false; refreshDrawer(); })
      .catch(function () { busy = false; btn.disabled = false; btn.textContent = 'Add all four'; });
  }

  /* Toggle, not add. Removing goes through purge so a duplicated line is cleared too. */
  function toggleOne(slug, btn, on) {
    if (busy) return;
    var m = MINI[slug];
    if (!m) return;
    busy = true; btn.disabled = true;
    (on ? purge(function (i) { return vid(i) === m.id && !isClaimed(i); }, 0)
        : add([{ id: m.id, quantity: 1 }]))
      .then(function () { busy = false; refreshDrawer(); })
      .catch(function () { busy = false; btn.disabled = false; });
  }

  function anchor() {
    return document.querySelector('[data-cro-crosssell]') || document.querySelector('.cart-drawer__footer');
  }
  function node() {
    var all = document.querySelectorAll('#sr-pair');
    for (var i = 1; i < all.length; i++) all[i].remove();
    return all[0] || null;
  }

  var productCache = {};
  function productFetch(handle) {
    if (productCache[handle] !== undefined) return Promise.resolve(productCache[handle]);
    return fetch(ROOT + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { productCache[handle] = null; return null; });
  }

  function forget() { lastHtml = null; lastAccent = null; lastC = null; lastMode = ''; }

  function wireInfo(el) {
    function showInfo(dot) {
      var slug = dot.getAttribute('data-sr-info');
      var slot = el.querySelector('[data-sr-pairslot]');
      if (!slot || !MINI[slug]) return;
      el.querySelectorAll('[data-sr-info]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      openInfo = slug;
      dot.setAttribute('aria-expanded', 'true');
      slot.innerHTML = '<div class="sr-pair__pop"><b>Bioactives</b>' + esc(MINI[slug].info) + '</div>';
    }
    function hideInfo() {
      var slot = el.querySelector('[data-sr-pairslot]');
      openInfo = null;
      if (slot) slot.innerHTML = '';
      el.querySelectorAll('[data-sr-info]').forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    }
    /* Capture phase, and preventDefault matters as much as stopPropagation: the dot sits over the
       add button, so a tap on it must not also add a mini. */
    el.addEventListener('click', function (e) {
      var dot = e.target && e.target.closest ? e.target.closest('[data-sr-info]') : null;
      if (!dot || !el.contains(dot)) return;
      e.preventDefault(); e.stopPropagation();
      if (openInfo === dot.getAttribute('data-sr-info')) { hideInfo(); return; }
      showInfo(dot);
    }, true);
    /* Pointer devices only: touch emits a synthetic mouseover, so the tooltip would stick. */
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      el.addEventListener('mouseover', function (e) {
        var dot = e.target && e.target.closest ? e.target.closest('[data-sr-info]') : null;
        if (dot && el.contains(dot)) showInfo(dot);
      });
      el.addEventListener('mouseout', function (e) {
        var dot = e.target && e.target.closest ? e.target.closest('[data-sr-info]') : null;
        if (!dot || !el.contains(dot)) return;
        var to = e.relatedTarget;
        if (to && to.closest && to.closest('[data-sr-info]') === dot) return;
        hideInfo();
      });
    }
  }

  function place(html, accent, c, mode) {
    var host = anchor();
    if (!host || !host.parentNode) return;
    var el = node();
    if (!el) { el = document.createElement('div'); el.id = 'sr-pair'; }
    el.className = 'sr-pair' + (mode === 'down' ? ' sr-pair--down' : '');
    if (el.parentNode !== host.parentNode || el.nextSibling !== host) host.parentNode.insertBefore(el, host);
    /* The downgrade is not an offer, so it does not silence the paid block. */
    document.documentElement.classList.toggle('sr-pair-on', mode !== 'down');
    el.style.setProperty('--pa', accent || '#0B312C');
    /* Compared on an attribute: the tooltip writes into the card, so innerHTML would wipe it. */
    if (el.getAttribute('data-html') !== html) {
      el.setAttribute('data-html', html);
      el.innerHTML = html;
      /* The popup lived in the markup that was just replaced, so the open-tooltip flag is stale. */
      openInfo = null;
      if (mode === 'down') {
        el.querySelectorAll('[data-sr-keep]').forEach(function (b) {
          b.addEventListener('click', function () { downgrade(this.getAttribute('data-sr-keep'), this); });
        });
      } else if (mode === 'otp-full' || mode === 'otp-mini') {
        var isFull = mode === 'otp-full';
        el.querySelector('.sr-pair__go').addEventListener('click', function () { addCollection(isFull, this); });
        el.querySelectorAll('[data-sr-one]').forEach(function (b) {
          b.addEventListener('click', function () {
            toggleOne(this.getAttribute('data-sr-one'), this, this.getAttribute('aria-pressed') === 'true');
          });
        });
        /* ONCE PER ELEMENT, NOT PER REBUILD. wireInfo delegates off the card, which survives innerHTML
           being replaced, so wiring it per rebuild stacked a second click listener on the same node.
           Two handlers sharing one openInfo cancel out - the first opens, the second closes - so every
           click was a dead tap. Hover hid it: both copies only ever show. */
        if (!el.__srInfoWired) { el.__srInfoWired = true; wireInfo(el); }
      } else {
        el.querySelector('.sr-pair__go').addEventListener('click', function () { convert(c, this); });
      }
    }
    lastHtml = html; lastAccent = accent; lastC = c; lastMode = mode;
  }

  /* The drawer rebuilds from the server and takes this card with it. Measured: gone 963ms, back
     1428ms. The observer sees it go before a frame paints. */
  function reattach() {
    if (!lastHtml) return;
    if (!document.querySelector('.cart-drawer__items [data-line-key]')) return;
    style();
    place(lastHtml, lastAccent, lastC, lastMode);
  }

  function tick() {
    return '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true" style="width:8px;height:8px"><path d="M1.5 6.2 L4.4 9 L10.5 3" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function render(cart) {
    var host = anchor();
    if (!host || !host.parentNode) return;

    var inCart = coupleInCart(cart);
    if (inCart) {
      style();
      var names = inCart.formulas.map(function (k) {
        return '<button type="button" class="sr-pair__dn" data-sr-keep="' + k + '">' + esc(FORMULA_NAME[k]) + '</button>';
      });
      place('<p class="sr-pair__dq">Only want one? Keep just ' + names[0] + ' or ' + names[1] + '.</p>', null, null, 'down');
      return;
    }

    var otp = otpCandidate(cart);
    if (otp) {
      productFetch(FULL.handle).then(function (p) {
        var wantId = otp.full ? FULL.id : MINIS_COL.id;
        var v = p && p.variants ? p.variants.filter(function (x) { return x.id === wantId; })[0] : null;
        if (!v || !v.available) {
          document.documentElement.classList.remove('sr-pair-on');
          forget();
          var gone = node(); if (gone) gone.remove();
          return;
        }
        style();
        var price = v.price || (otp.full ? FULL.price : MINIS_COL.price);
        var single = otp.full ? FIFTY_PRICE : MINI_PRICE;
        var head, sub, shot;
        if (otp.full) {
          head = 'Get the fourth bottle <b>free</b>';
          sub = 'Costs less than just three at ' + money(single * 3) + '. All four is <b>' + money(price) + '</b>.';
          shot = '<img class="sr-pair__shot" src="' + CDN + FULL.img + '?width=700" alt="All four Superoom 50ml bottles" loading="lazy">';
        } else {
          head = 'All four minis, <b>' + money(Math.round(price / 4)) + ' a bottle</b>';
          sub = 'One 15ml is ' + money(single) + '. All four is <b>' + money(price) + '</b>.';
          shot = '<img class="sr-pair__shot sr-pair__shot--fit" src="' + CDN + MINIS_COL.img + '?width=700" alt="All four Superoom 15ml minis" loading="lazy">';
        }
        var ones = SLUGS.map(function (s) {
          var m = MINI[s], on = !!otp.held[s];
          return '<div class="sr-pair__cell" data-on="' + (on ? '1' : '0') + '">'
            + '<button type="button" class="sr-pair__one" data-sr-one="' + s + '" aria-pressed="' + (on ? 'true' : 'false')
            + '" aria-label="' + (on ? 'Remove the ' + esc(m.name) + ' 15ml mini' : 'Add a ' + esc(m.name) + ' 15ml mini for ' + money(MINI_PRICE)) + '">'
            + '<img src="' + CDN + m.img + '?width=90" alt="" loading="lazy">'
            + '<span class="sr-pair__on">' + esc(m.name) + '</span>'
            + '<span class="sr-pair__op">' + money(MINI_PRICE) + '</span></button>'
            + '<span class="sr-pair__tick">' + tick() + '</span>'
            + '<i class="sr-pair__i" data-sr-info="' + s + '" role="button" tabindex="0" aria-expanded="false"'
            + ' aria-label="What ' + esc(m.name) + ' is">i</i></div>';
        }).join('');
        /* From the second mini on, singles cost more than the set: 55.98 against 54.99. Saying so is
           the difference between an upsell and a trap. */
        var n = otp.qty, sum;
        if (!n) sum = money(MINI_PRICE) + ' each. Add as many as you like.';
        else if (n === 1) sum = 'One mini, ' + money(MINI_PRICE) + '.' + (otp.full ? '' : ' All four is <b>' + money(MINIS_COL.price) + '</b>.');
        else sum = n + ' minis, ' + money(n * MINI_PRICE) + '. All four is <b>' + money(MINIS_COL.price) + '</b>.';
        place('<span class="sr-pair__tag">Better value</span>'
          + '<p class="sr-pair__t">' + head + '</p>'
          + '<p class="sr-pair__s">' + sub + '</p>'
          + shot
          + '<div class="sr-pair__row"><button type="button" class="sr-pair__go">Add all four · ' + money(price) + '</button></div>'
          + '<p class="sr-pair__or">Or pick the minis you want</p>'
          + '<div class="sr-pair__ones">' + ones + '</div>'
          + '<p class="sr-pair__sum">' + sum + '</p>'
          + '<div class="sr-pair__slot" data-sr-pairslot></div>',
          '#0B312C', null, otp.full ? 'otp-full' : 'otp-mini');
      });
      return;
    }

    var c = candidate(cart);
    if (!c) {
      document.documentElement.classList.remove('sr-pair-on');
      forget();
      var gone2 = node(); if (gone2) gone2.remove();
      return;
    }

    productFetch(c.pair.handle).then(function (p) {
      if (!p || !p.available) {
        document.documentElement.classList.remove('sr-pair-on');
        forget();
        var el = node(); if (el) el.remove();
        return;
      }
      var theirs = c.line.final_line_price / c.line.quantity;
      var saving = (theirs * 2) - 6999;
      style();
      var savingLine = saving > 0
        ? '<b>' + money(saving) + ' a month less</b> than two subscriptions.'
        : 'Two formulas on one subscription.';
      var lead = c.followsGift
        ? esc(c.pair.partner) + ' full size, alongside your ' + esc(FORMULA_NAME[c.key]) + '. '
        : 'Add ' + esc(c.pair.partner) + ' to your ' + esc(FORMULA_NAME[c.key]) + '. ';
      place('<span class="sr-pair__tag">Upgrade</span>'
        + '<p class="sr-pair__t">Make it <b>' + esc(c.pair.title) + '</b></p>'
        + '<p class="sr-pair__s">' + lead + savingLine + '</p>'
        + '<div class="sr-pair__row"><button type="button" class="sr-pair__go">Make it a Power Couple</button></div>',
        c.pair.accent, c, 'up');
    });
  }

  function run() {
    if (busy) return;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(run, 140); }

  function init() {
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.documentElement.addEventListener('cart:change', schedule);
    document.documentElement.addEventListener('cart:refresh', schedule);
    new MutationObserver(function () {
      if (document.getElementById('sr-pair')) return;
      reattach();
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
    run();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
